var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gallery"},_vm._l((_vm.sources),function(s,i){return _c('img',{key:i,attrs:{"src":s,"alt":"img"},on:{"click":function($event){return _setup.handleImageClick(i)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }